import {
	Component,
	EventEmitter,
	Input,
	NgZone,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../provider/user/user.service';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {
	BinaryTypeList,
	ConfigurationObject,
	FileInfoObj,
	FileObj,
	FilesInfoResponseObj, LockObject
} from '../../interfaces/interfaces.regisafe';
import {StorageService} from '../../provider/storage/storage.service';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {AlertController, LoadingController, ModalController, Platform, ToastController} from '@ionic/angular';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {AppConfig} from '../../app.config';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {Directory, Filesystem, GetUriOptions} from '@capacitor/filesystem';
import {Capacitor} from '@capacitor/core';
import {FileOpener} from '@awesome-cordova-plugins/file-opener/ngx';
import write_blob, {BlobWriteOptions} from 'capacitor-blob-writer';
import {APP_EDIT_FOLDER, APP_STORAGE} from '../../../environments/environment';
import {FileTransfer, FileTransferObject, FileUploadOptions} from '@awesome-cordova-plugins/file-transfer/ngx';
import {MessagesService} from '../../provider/messages/messages.service';
import {ALERT_TXT} from '../../strings/language';
import {App} from '@capacitor/app';
import {FileOpener as FileOpenerCom, FileOpenerOptions} from '@capacitor-community/file-opener';
import {RegisafeMsgViewerComponent} from '../regisafe-msg-viewer/regisafe-msg-viewer.component';
import {Subscription} from 'rxjs';

declare let cordova: any;

@Component({
	selector: 'app-regisafe-getfileinfo',
	templateUrl: './regisafe-getfileinfo.component.html',
	styleUrls: ['./regisafe-getfileinfo.component.scss'],
})
export class RegisafeGetfileinfoComponent implements OnInit, OnChanges {

	@Input() details: object;
	@Input() objectLocked: boolean;
	@Output() objectLockedState: EventEmitter<any> = new EventEmitter<any>();

	public configuration: ConfigurationObject;

	osid: string;
	objid: string;
	objidToFolder: string;
	filesCount: number;
	filesObj: object;
	filesArr: Array<any> = [];
	alert = null;
	loaded = 0;
	total = 0;
	inProgress = false;
	currentFile: any;
	filerefresh: boolean;
	//objectLocked = false;
	loader: HTMLIonLoadingElement;
	modal: HTMLIonModalElement;
	toast: HTMLIonToastElement;
	progress: any = 0;

	client: Subscription;

	constructor(private activatedRoute: ActivatedRoute,
				private router: Router,
				public userService: UserService,
				private iqAPI: IQApiService,
				private storageService: StorageService,
				private errorHandling: ErrorHandlingService,
				private platform: Platform,
				private alertCtrl: AlertController,
				private modalCtrl: ModalController,
				private toastCtrl: ToastController,
				private dateiSystem: DateiSystemService,
				public appConfig: AppConfig,
				private httpClient: HttpClient,
				private fileOpener: FileOpener,
				private dateiSystemService: DateiSystemService,
				private loadingCtrl: LoadingController,
				private transfer: FileTransfer,
				public zone: NgZone,
				private msgService: MessagesService) {

		this.configuration = this.appConfig.getConfig();

		this.setupListener();

	}

	async setupListener() {
		App.addListener('appStateChange', ({isActive}) => {
			if (!isActive) {
				console.log('## is not active ###');
			} else {
				console.log('## is active ##');
			}
		});
	}

	async ngOnInit() {
		this.osid = this.activatedRoute.snapshot.paramMap.get('osid');
		this.objid = this.userService.objIdAsIQAPIParam(this.activatedRoute.snapshot.paramMap.get('objid'));
		this.objidToFolder = this.activatedRoute.snapshot.paramMap.get('objid');
		this.getFileInfo(this.osid, this.objid);
		this.checkObjectIsLocked();

		// do some Stuff here if App becomes from Background to Front
		this.platform.resume.subscribe(() => {
			if (!this.currentFile) {
				return false;
			}

			this.dateiSystemService.getFileInfo(this.currentFile.path + '/' + this.currentFile.name)
				.then(async (result) => {
					console.log('getFileInfo: ', result);
					console.log('this.currentFile.appMTime: ', this.currentFile.appMTime);

					if (this.currentFile.appMTime === result.mtime) {
						this.errorHandling.errorMessage('Das Schriftstück wurde in die Bearbeitungsliste übernommen. Es wurde keine Änderung vorgenommen.', 'toast', false);
						this.currentFile = null;
					} else {
						console.log('Datei wurde verändert!!!');
						const alert = await this.alertCtrl.create({
							header: ALERT_TXT.header.str00020,
							subHeader: ALERT_TXT.subHeader.str00020,
							buttons: [{
								text: ALERT_TXT.buttons.str00050,
								handler: () => {
									this.writeFile();
								}
							}, {
								text: ALERT_TXT.buttons.str00010,
								role: 'cancel',
								handler: () => {
									// eslint-disable-next-line max-len
									this.errorHandling.errorMessage('Das Schriftstück wurde in die Bearbeitungsliste übernommen.', 'toast', false);
								}
							}]
						});

						await alert.present();
					}
				})
				.catch((e) => {
					console.log('RESUME ERROR: ', this.currentFile.path + '/' + this.currentFile.name);
					console.log('RESUME ERROR: ', e);
				});
		});
	}

	async writeFile() {

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}

		const options: LockObject = {
			objID: this.objid,
			osId: this.osid,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
		};

		const unlockObject = await this.iqAPI.orgaManagerUnlockObject(options)
			.toPromise()
			.catch((errorResponse) => {

				if (errorResponse.hasOwnProperty('error')) {
					if (errorResponse.error.hasOwnProperty('_error')) {

						// 116011: Schriftstück war nicht zur Bearbeitung gesperrt
						// eslint-disable-next-line no-underscore-dangle
						if (errorResponse.error._error[1].errNo === 116011) {
							this.objectLocked = false;
							this.objectLockedState.emit(false);
							const setUnLocked = this.storageService.removeLockedObject(this.objid);
						}
					}
				}

				this.errorHandling.handleError(errorResponse, 'getFile -> orgaManagerLockObject');
			});


		if (unlockObject) {
			if (unlockObject.hasOwnProperty('status')) {
				if (unlockObject.status === 1) {

					const parameter = {
						apiID: this.configuration.iqapiAppId,
						sessionToken: this.storageService.getToken(),
						osId: this.osid,
						objId: this.userService.objIdAsIQAPIParam(this.objid), // 0:0 od 123:456
						fileName: this.currentFile.name,
						fileAdd: 2
					};

					const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';
					const fileTransfer: FileTransferObject = this.transfer.create();
					const transferOption: FileUploadOptions = {
						fileKey: 'binary',
						fileName: this.currentFile.name,
						mimeType: this.currentFile.mimeType,
						httpMethod: 'POST',
						chunkedMode: false,
						params: parameter
					};

					fileTransfer.onProgress((progressEvent) => {
						if (progressEvent.lengthComputable) {
							// eslint-disable-next-line max-len
							this.progress = Math.floor(progressEvent.loaded / progressEvent.total * 100) + '% / ' + this.userService.niceBytes(progressEvent.loaded);
							this.loader.message = this.progress;
							this.zone.run(() => {
							});
						} else {
							console.log('progressEvent.lengthComputable: ', progressEvent.lengthComputable);
						}

					});

					fileTransfer.upload(this.currentFile.uri, url, transferOption, true)
						.catch((e) => {
							console.log('fileTransfer.upload error: ', e);
							const errorResponse = {
								error: JSON.parse(e.body)
							};
							this.dismissLoader();
							this.errorHandling.handleError(errorResponse, 'InBearbeitungPage -> writeFileInLoop -> fileTransfer.upload');
						})
						.then(async (result: any) => {
							console.log('transferObj result: ', result);
							if (!result) {
								console.log('Fehler beim Upload!!!');
								this.progress = 0;
								return false;
							}

							this.objectLocked = false;
							this.objectLockedState.emit(false);

							const removeLockedObj = await this.storageService.removeLockedObject(this.objid);
							// eslint-disable-next-line max-len
							const removeSchriftgutObj = await this.storageService.removeObjectFromSchriftgut(this.userService.objIdAsRouteParam(this.objid));
							// eslint-disable-next-line max-len
							const removeFile = await this.dateiSystemService.loescheDatei(APP_EDIT_FOLDER + this.userService.objIdAsRouteParam(this.objid) + '/' + this.currentFile.name);

							this.progress = 0;
							this.dismissLoader();

							if (removeFile) {
								this.currentFile = null;
							} else {
								console.log('removeFile: ', removeFile);
							}

						});
				}
			}
		}

	}

	ngOnChanges(changes: SimpleChanges) {
		this.checkObjectIsLocked();
	}

	public getFileIcon(filename: string): any {
		const extension = filename.split('.').pop();

		const iconList: any = {};
		iconList.default = ['far', 'file-lines'];

		iconList.doc = ['far', 'file-word'];
		iconList.docx = ['far', 'file-word'];
		iconList.xls = ['far', 'file-excel'];
		iconList.xlsx = ['far', 'file-excel'];

		iconList.rtf = ['far', 'file-lines'];
		iconList.txt = ['far', 'file-lines'];

		iconList.pdf = ['far', 'file-pdf'];

		iconList.jpg = ['far', 'file-image'];
		iconList.jpeg = ['far', 'file-image'];
		iconList.png = ['far', 'file-image'];

		iconList.msg = ['far', 'envelope'];

		if (iconList.hasOwnProperty(extension)) {
			return iconList[extension];
		} else {
			return iconList.default;
		}

	}

	public getFileTypeByExtension(filename: string) {
		const extension = filename.split('.').pop();
		const typeList: any = {};
		typeList.msg = 'msg';

		if (typeList.hasOwnProperty(extension)) {
			return typeList[extension];
		} else {
			return typeList.default;
		}
	}

	public getFileInfo(osid, objid, refresh?: boolean) {

		if (refresh) {
			this.filerefresh = true;
			this.filesArr = [];
		}

		// BODY Object erstellen
		const body: FileInfoObj = {
			osId: osid,
			objID: objid,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			keepOrigName: 0
		};

		this.iqAPI.orgaManagerGetFileInfo(body).subscribe(
			(result: FilesInfoResponseObj) => {

				this.filesCount = result.filesCount;
				this.filesObj = result.files;
				this.filerefresh = false;

				Object.keys(this.filesObj).forEach((key) => {
					this.filesArr.push({
						filename: key,
						filesize: this.userService.niceBytes(this.filesObj[key].size),
						lastchange: this.filesObj[key].lastchange,
						fileicon: this.getFileIcon(key),
						filetype: this.getFileTypeByExtension(key)
					});
				});

			}, (error) => {
				console.log('getFileInfo error: ', error);
				this.filerefresh = false;
				this.errorHandling.handleError(error, 'RegisafeGetfileinfoComponent -> getFileInfo');
			});
	}

	public async lockObject(): Promise<boolean> {
		// Dokument sperren
		const options: LockObject = {
			objID: this.objid,
			osId: this.osid,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
		};

		const lockObject = await this.iqAPI.orgaManagerLockObject(options)
			.toPromise()
			.catch((errorResponse) => {
				console.log('lockObject errorResponse: ', errorResponse);

				if (errorResponse.hasOwnProperty('error')) {
					if (errorResponse.error.hasOwnProperty('_error')) {

						// eslint-disable-next-line max-len
						// 116326: Schriftstück {000000} \"xyz\" wurde bereits heute um hh:mm Uhr durch Sie zur Bearbeitung mit der regisafe-App gesperrt.
						// eslint-disable-next-line no-underscore-dangle
						if (errorResponse.error._error[1].errNo === 116326) {
							this.objectLocked = true;
							this.objectLockedState.emit(true);
							const setLocked = this.storageService.setLockedObject(this.objid);
						}
					}
				}
				this.errorHandling.handleError(errorResponse, 'getFile -> orgaManagerLockObject');
			});

		console.log('lockObject stat: ', lockObject);

		if (lockObject) {
			if (lockObject.hasOwnProperty('status')) {
				if (lockObject.status === 1) {
					this.objectLocked = true;
					this.objectLockedState.emit(true);
					const setLocked = this.storageService.setLockedObject(this.objid);
					console.log('setLocked: ', setLocked);
				}
			}
			return true;
		} else {
			return false;
		}
	}

	public async unlockObject() {
		const options: LockObject = {
			objID: this.objid,
			osId: this.osid,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
		};

		const unlockObject = await this.iqAPI.orgaManagerUnlockObject(options)
			.toPromise()
			.catch((errorResponse) => {
				console.log('unlockObject errorResponse: ', errorResponse);

				if (errorResponse.hasOwnProperty('error')) {
					if (errorResponse.error.hasOwnProperty('_error')) {

						// 116011: Schriftstück war nicht zur Bearbeitung gesperrt
						// eslint-disable-next-line no-underscore-dangle
						if (errorResponse.error._error[1].errNo === 116011) {
							this.objectLocked = false;
							this.objectLockedState.emit(false);
							const setUnLocked = this.storageService.removeLockedObject(this.objid);
						}
					}
				}

				this.errorHandling.handleError(errorResponse, 'getFile -> orgaManagerLockObject');
			});

		if (unlockObject) {
			if (unlockObject.hasOwnProperty('status')) {
				if (unlockObject.status === 1) {
					this.objectLocked = false;
					this.objectLockedState.emit(false);
					this.storageService.removeLockedObject(this.objid);
				}
			}
		}
	}

	// http://localhost:8105/#/regisafe/detail/Schriftgutverwaltung/2110--14973
	// http://localhost:8105/#/regisafe/detail/Schriftgutverwaltung/2110--199705
	public async checkObjectIsLocked() {
		const lockedObjects = await this.storageService.getLockedObjects();
		const userData = await this.storageService.getConditions('user');
		const userId = userData.userId;

		if (lockedObjects.hasOwnProperty(userId)) {
			console.log('lockedObjects: ', lockedObjects);

			if (lockedObjects[userId].includes(this.objid)) {
				this.objectLocked = true;
				this.objectLockedState.emit(true);
			} else {
				this.objectLocked = false;
				this.objectLockedState.emit(false);
			}
		}
	}


	public async openFileForEdit(file, item?) {

		if (item) {
			item.close();
		}

		console.log('FILE: ', file);

		if (file.filetype === 'msg') {
			this.errorHandling.errorMessage('Dieser Datei-Typ kann nicht bearbeitet werden.', 'toast', false);
			return false;
		}

		this.msgService.sendMessage({filesInProgress: true});

		// Dokument sperren
		if (!this.objectLocked) {
			const lock = this.lockObject()
				.then((res) => {
					if (res) {
						this.getFile(file);
					} else {
						this.msgService.sendMessage({filesInProgress: false});
						console.log('Object ist bereits gesperrt!');
					}
				});
		} else {
			this.getFile(file);
		}
	}

	public async getFile(file: any) {

		// if (!this.loader) {
		// 	this.loader = await this.loadingCtrl.create({duration: 5000});
		// 	await this.loader.present();
		// }

		if (!this.alert) {
			// this.loader = await this.loadingCtrl.create({duration: 10000});
			// await this.loader.present();
			this.alert = await this.alertCtrl.create({
				header: 'Download',
				subHeader: 'Bitte warten Sie',
				backdropDismiss: false,
				buttons: [{
					text: 'Abbrechen',
					handler: () => {
						this.client.unsubscribe();
						this.alert = null;
					}
				}]
			});
			this.alert.present();
		}

		const binaryType: BinaryTypeList = 'DownloadLink';
		const body: FileObj = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: this.osid,
			objId: this.objid,
			fileName: file.filename,
			maxSize: 134217728,
			format: '',
			keepOrigName: 0,
			binaryOutType: binaryType
		};

		const result: any = await this.iqAPI.orgaManagerGetFile(body)
			.toPromise()
			.catch((error) => {
				this.errorHandling.handleError(error, 'getFile -> orgaManagerGetFile');
				// this.dismissLoader();
				this.dismissAlert();
			});

		if (result) {
			const filename = result.fileName;
			const url = result.binary.replace(/^\/+/g, ''); // entfernt führenden Slash ('/') von der URL
			// this.dismissLoader();
			// this.dismissAlert();

			if (Capacitor.getPlatform() !== 'web') {

				const objectFolderExists = await this.dateiSystem.pruefeAppOrder(APP_EDIT_FOLDER + this.objidToFolder);
				if (objectFolderExists) {
					this.downlodBinary(url, filename);
				} else {
					const objectFolderCreate = await this.dateiSystem.erstelleAppOrdner(APP_EDIT_FOLDER + this.objidToFolder);
					if (objectFolderCreate) {
						this.downlodBinary(url, filename);
					}
				}
			} else {
				// this.downlodBinary(url, filename);
				window.open(this.configuration.iqapiDomain + result.binary, '_system');
			}
		} else {
			console.log('result error: ', result);
			// this.dismissLoader();
			this.dismissAlert();
		}
	}

	/**
	 * https://files-example-com.github.io/uploads/files-sample_500kB.docx
	 * https://files-example-com.github.io/uploads/files_example_MP4_1920_18MG.mp4
	 */
	public downlodBinary(url: string, filename: string) {

		this.inProgress = true;
		const path = this.configuration.iqapiDomain + url;

		console.log('### downlodBinary path ###: ', path);

		this.httpClient.get(path,
			{
				responseType: 'blob',
				reportProgress: true,
				observe: 'events'
			})
			.subscribe((event) => {
				if (event.type === HttpEventType.DownloadProgress) {
					this.loaded = event.loaded;
					this.total = event.total;

					// eslint-disable-next-line max-len
					// this.loader.message = this.userService.niceBytes(event.loaded).toString() + ' / ' + this.userService.niceBytes(event.total).toString();
					console.log('++++++++++: ', this.alert);
					console.log('++++++++++: ', this.alert.subHeader);
					this.alert.subHeader = this.userService.niceBytes(event.loaded).toString() + ' / ' + this.userService.niceBytes(event.total).toString();

					this.zone.run(() => {
					});

				} else if (event.type === HttpEventType.Response) {
					this.inProgress = false;
					const mime = event.body.type;
					const options: BlobWriteOptions = {
						path: APP_EDIT_FOLDER + this.objidToFolder + '/' + filename,
						directory: Directory.Documents,
						blob: event.body,
						recursive: true
					};
					// this.dismissLoader();
					this.dismissAlert();

					write_blob(options)
						.then((data) => {
							const optionsGetUri: GetUriOptions = {
								directory: Directory.Documents,
								path: APP_EDIT_FOLDER + this.objidToFolder + '/' + filename
							};

							Filesystem.stat(optionsGetUri)
								.then((res) => {
									// Store Document-Meta-Information in Storage
									const metaInfo = {
										uri: res.uri,
										path: APP_EDIT_FOLDER + this.objidToFolder,
										name: filename,
										objid: this.objidToFolder,
										osid: this.osid,
										details: this.details[0],
										appCTime: res.ctime,
										appMTime: res.mtime,
										mimeType: mime
									};
									this.storageService.storeFileMetaInformations(metaInfo);
									this.currentFile = metaInfo;

									// TODO: - iPad öffnet Datei nicht (Fehler)
									// TODO: https://github.com/capacitor-community/file-opener
									if (Capacitor.getPlatform() === 'ios') {

										const comOptions: FileOpenerOptions = {
											filePath: res.uri,
											contentType: mime,
											openWithDefault: false
										};
										FileOpenerCom.open(comOptions)
											.then(() => {
												console.log('### FOCom: ');
											})
											.catch((e) => {
												console.log('### FOCom error: ', e);
											});
									} else {

										let fileOpenercomundus = null;
										try {
											fileOpenercomundus = cordova.plugins.fileOpener2comundus;
										} catch (e) {
											console.log('Lorem: ', e);
										}
										// Open Document
										fileOpenercomundus.showOpenWithDialog(res.uri, mime, {
											// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
											success() {
												console.log('showOpenWithDialog');
											},
											// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
											error(e) {
												console.log('showOpenWithDialog error: ', e);
												this.currentFile = null;
											}
										});
									}
								})
								.catch((error) => {
									console.log('getURI error: ', error);
								});

							//
						})
						.catch((e) => {
							console.log('error: ', e);
						});

				}
			}, (error) => {
				this.errorHandling.handleError(error, 'downlodBinary -> get');
			});
	}

	async dismissLoader() {
		try {
			this.loader.dismiss();
			this.loader = null;
		} catch (e) {
			console.log('dismissToast: ', e);
		}
	}

	async dismissAlert() {
		try {
			this.alert.dismiss();
			this.alert = null;
		} catch (e) {
			console.log('dismissAlert: ', e);
		}
	}

	async openFileForView(file, item) {

		if (item) {
			item.close();
		}

		if (!this.alert) {
			// this.loader = await this.loadingCtrl.create({duration: 10000});
			// await this.loader.present();
			this.alert = await this.alertCtrl.create({
				header: 'Download',
				subHeader: 'Bitte warten Sie',
				backdropDismiss: false,
				buttons: [{
					text: 'Abbrechen',
					handler: () => {
						this.client.unsubscribe();
						this.alert = null;
					}
				}]
			});
			this.alert.present();
		}

		const binaryType: BinaryTypeList = 'DownloadLink';
		const body: FileObj = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: this.osid,
			objId: this.objid,
			fileName: file.filename,
			maxSize: 134217728,
			format: '',
			keepOrigName: 0,
			binaryOutType: binaryType
		};

		const result: any = await this.iqAPI.orgaManagerGetFile(body)
			.toPromise()
			.catch((error) => {
				this.errorHandling.handleError(error, 'getFile -> orgaManagerGetFile');
				// this.dismissLoader();
				this.dismissAlert();
			});

		if (result) {
			const filename = result.fileName;
			const url = result.binary.replace(/^\/+/g, ''); // entfernt führenden Slash ('/') von der URL;

			if (Capacitor.getPlatform() !== 'web') {
				this.downlodBinaryToCache(url, filename);
			} else {
				// this.downlodBinaryToCache(url, filename);
				window.open(this.configuration.iqapiDomain + result.binary, '_system');
			}
		} else {
			console.log('result error: ', result);
			// this.dismissLoader();
			this.dismissAlert();
		}
	}

	downlodBinaryToCache(url: string, filename: string) {
		this.inProgress = true;
		const path = this.configuration.iqapiDomain + url;
		this.client = this.httpClient.get(path,
			{
				responseType: 'blob',
				reportProgress: true,
				observe: 'events'
			})
			.subscribe((event) => {

				if (event.type === HttpEventType.DownloadProgress) {
					this.loaded = event.loaded;
					this.total = event.total;

					// eslint-disable-next-line max-len
					// this.loader.message = this.userService.niceBytes(event.loaded).toString() + ' / ' + this.userService.niceBytes(event.total).toString();
					this.alert.subHeader = this.userService.niceBytes(event.loaded).toString() + ' / ' + this.userService.niceBytes(event.total).toString();

					this.zone.run(() => {
					});

				} else if (event.type === HttpEventType.Response) {
					this.inProgress = false;

					const mime = event.body.type;
					const options: BlobWriteOptions = {
						path: filename,
						directory: Directory.Cache,
						blob: event.body,
						recursive: true
					};

					//this.dismissLoader();
					this.dismissAlert();

					write_blob(options)
						.then((data) => {

							const extension = data.split('.').pop();
							if (extension === 'msg') {

								event.body.arrayBuffer()
									.catch((e) => {
										this.errorHandling.handleError(e, 'downlodBinaryToCache -> write_blob');
									})
									.then((buffer: ArrayBuffer) => {
										this.openMSGModalViewer(buffer);
									});

								return false;
							}

							if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {

								const comOptions: FileOpenerOptions = {
									filePath: data,
									contentType: mime,
									openWithDefault: true
								};
								FileOpenerCom.open(comOptions)
									.then(() => {
										console.log('### FOCom: ');
									})
									.catch((e) => {
										console.log('### FOCom error: ', e);
									});
							} else {
								// Android
								this.openInDefaultViewer(data, mime);
							}


						})
						.catch((error) => {
							console.log('getURI error: ', error);
						});
				}
			}, (error) => {
				this.errorHandling.handleError(error, 'downlodBinaryToCache -> get');
			});
	}

	openInDefaultViewer(url: string, mimetype: string) {
		let fileOpenercomundus = null;
		const $this = this;
		try {
			fileOpenercomundus = cordova.plugins.fileOpener2comundus;
		} catch (e) {
			console.log('Lorem: ', e);
		}
		// Open Document
		fileOpenercomundus.open(url, mimetype, {
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			success() {
				console.log('openInDefaultViewer -> open');
			},
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			error(e) {
				console.log('openInDefaultViewer -> error: ', e);
				if (e.status === 9) {
					$this.openWidthDialog(url, mimetype)
				} else {
					$this.errorHandling.handleError(e, 'openInDefaultViewer -> fileOpenercomundus.open')
				}
			}
		});
	}

	async openMSGModalViewer(buffer: ArrayBuffer) {
		const props = {
			buffer
		};

		this.modal = await this.modalCtrl.create({
			component: RegisafeMsgViewerComponent,
			componentProps: props
		});
		this.modal.present();
	}

	openWidthDialog(url: string, mimetype: string) {
		let fileOpenercomundus = null;
		const $this = this;
		try {
			fileOpenercomundus = cordova.plugins.fileOpener2comundus;
		} catch (e) {
			console.log('Lorem: ', e);
		}
		// Open Document
		fileOpenercomundus.showOpenWithDialog(url, mimetype, {
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			success() {
				console.log('openWidthDialog -> open');
			},
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			error(e) {
				console.log('openWidthDialog -> error: ', e);
				$this.errorHandling.handleError(e, 'openWidthDialog -> fileOpenercomundus.openWidthDialog')
			}
		});
	}

	async checkOpenFileWith(file) {
		const defaultViewer = await this.storageService.getItem(APP_STORAGE.user.opendocsindefaultviewer);
		if (defaultViewer === 1) {
			this.openFileForView(file, null);
		} else {
			this.openFileForEdit(file, null);
		}
	}
}
